module.exports = {
	"header": "Spotin X Arctic15",
	"date": "2022/06/01",
	"imgSrc": "SpotinxArctic15.png",
	"imgAlt": "Spotin x Arctic15",
	"ingress": "Come see Spotin at the Arctic15 Helsinki startup conference (7th-8th June, 2022). We are looking forward to meeting investors operating in late seed/A-rounds and seeking strategic partnerships for business expansion in Europe and US with brands and publishers.",
	"sections": [
		{
			"paragraphs": [
				"Spotin is on a mission to make commerce friction-free by connecting brands with content creators/publishers and bringing a variety of technology solutions for the e-commerce industry. Some of our current business partners are, Bonnier group, Vogue Scandinavia, Creator studio and a range of selling parties within a variety of industries.",
				"We are participating on both days of the event (7th-8th June) and will be exhibiting at stall no.22 on 7th June. Our CFO and Co-Founder, Robert Karlsson along with our marketing team will be present there. You can book a meeting via the official deal room of Arctic15 or simply walk-in and meet us at stall no. 22. For any additional inquiries you can email us at marketing@spotin.com and we will get back to you."
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./pages/news/5/article.json
// module id = 18
// module chunks = 0